import _ from 'lodash';
import { combineReducers } from 'redux';
import global, { localStorePaths as globalLocalStorePaths } from './global';
import studio, { localStorePaths as studioLocalStorePaths } from './studio/';
import org, { localStorePaths as orgStorePaths } from './org';
import wizard, { localStorePaths as wizardLocalStorePaths } from './wizard';

const rootReducer = combineReducers({
    global,
    studio,
    org,
    wizard
});

export default rootReducer;

export const localStorePaths = _.omitBy(
    {
        global: globalLocalStorePaths,
        studio: studioLocalStorePaths,
        org: orgStorePaths,
        wizard: wizardLocalStorePaths
    },
    _.isEmpty
);
